import { render, staticRenderFns } from "./questionTotal.vue?vue&type=template&id=562ab24b&scoped=true&"
import script from "./questionTotal.vue?vue&type=script&lang=js&"
export * from "./questionTotal.vue?vue&type=script&lang=js&"
import style0 from "./questionTotal.vue?vue&type=style&index=0&id=562ab24b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ab24b",
  null
  
)

export default component.exports